import { ErrorTypography, Typography } from '@src/common/components/Typography';
import { useTranslation } from 'react-i18next';

export const NoAxleInformation = ({
  missingAxlesError,
}: {
  missingAxlesError?: boolean;
}) => {
  const { t } = useTranslation();

  if (missingAxlesError) {
    return <ErrorTypography>{t('noAxleInformation')}</ErrorTypography>;
  }

  return <Typography>{t('noAxleInformation')}</Typography>;
};
